import * as React from "react";

function DollarSignIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M184 73.46c27.3 2.8 52.8 8.1 71.5 12.52 12.9 3.05 20.9 15.12 17.9 28.92-3.1 12.9-16 20.8-28.9 17.8-30.8-7.3-75.6-15.7-113.9-12.5-19 1.5-34.42 4.9-45.33 12.7-10.08 6.4-17.29 15.6-20.18 30.4-2.27 11.7-.69 19.2 1.96 24.6 2.82 5.6 8.09 11.2 17.14 16.8 19.21 11.9 46.91 19.4 81.71 28l2.3.6c31 7.9 66.7 17 92.9 33.2 13.9 8.6 26.8 20.2 34.8 36.2 8.1 15.4 9.2 34.8 6.1 55.1-6.9 35.4-32.6 58.5-64.5 70.6-16.1 6.2-34.2 9.8-53.5 11V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-49.7l-9.9-1.2-1-.1c-24-3.6-68.08-13.8-94.85-25.7-12.11-5.4-17.56-19.6-12.18-31.7 5.38-12.1 19.57-17.6 31.68-12.2 21.21 9.4 60.45 18.8 83.05 22.1 35.6 5 66 2.3 87.6-5.9 21.1-8.1 31.7-20.3 34.5-34.9 2.3-12.6.7-19.2-2-24.6-2.8-5.6-8-11.2-17.1-16.8-19.2-11.9-47.8-19.4-81.7-28l-2.3-.6c-31-7.9-66.71-17-92.88-33.2-13.94-8.6-26.79-20.2-34.8-36.2-8.16-16.3-10.09-34.8-6.14-55.1 5.48-29.1 20.73-48.6 41.56-61.81 20-12.71 43.96-18.19 67.16-20.07 3.1-.25 6.2-.44 9.3-.58V24c0-13.25 10.7-24 24-24s24 10.75 24 24v49.46z"
  }));
}

const ForwardRef = React.forwardRef(DollarSignIcon);
export default ForwardRef;